import React from 'react';

export const ImageGrid = React.lazy(() => import('./ImageGrid'));
